import { frontendURL } from '../../../helper/URLHelper';
import TicketsIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ardhisasa/tickets'),
    name: 'ardhisasa_tickets',
    component: TicketsIndex,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
